import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GlassCard } from '../../components';
import './PolicyScreen.css';

export const RefundScreen = () => {
    const navigate = useNavigate();

    return (
        <div className="policy-screen">
            <div className="screen-header">
                <button className="back-btn" onClick={() => navigate(-1)}>
                    <span className="material-icons">arrow_back</span>
                </button>
                <h1 className="screen-title">Refund Policy</h1>
                <div style={{ width: 40 }}></div>
            </div>

            <div className="policy-content">
                <p className="last-updated">Last Updated: January 2026</p>

                <GlassCard className="policy-card">
                    <h2>1. Overview</h2>
                    <p>
                        This Refund Policy outlines the conditions under which refunds may be issued for transactions made on the Yonex AI platform. We strive to ensure fair and transparent handling of all refund requests.
                    </p>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>2. Deposit Refunds</h2>
                    <p>
                        Deposits made to your Yonex AI account are generally non-refundable once credited. However, refunds may be considered in the following circumstances:
                    </p>
                    <ul>
                        <li>Technical errors resulting in duplicate charges</li>
                        <li>Unauthorized transactions (subject to investigation)</li>
                        <li>Failed deposits that were deducted from your bank</li>
                    </ul>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>3. Investment Products</h2>
                    <p>
                        Once you have purchased an investment product (mining node/plan):
                    </p>
                    <ul>
                        <li>The investment cannot be cancelled or refunded</li>
                        <li>Daily income will be credited as per the product terms</li>
                        <li>The investment will complete its full duration</li>
                        <li>Principal + returns will be credited upon completion</li>
                    </ul>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>4. Withdrawal Reversals</h2>
                    <p>
                        Withdrawal requests cannot be reversed once submitted. Please ensure:
                    </p>
                    <ul>
                        <li>Bank details are accurate before submitting</li>
                        <li>The withdrawal amount is correct</li>
                        <li>Your fund password is secure</li>
                    </ul>
                    <p>
                        If a withdrawal fails due to incorrect bank details, the amount will be credited back to your account after verification.
                    </p>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>5. Refund Processing Time</h2>
                    <p>
                        If a refund is approved:
                    </p>
                    <ul>
                        <li>Refunds to bank account: 5-7 business days</li>
                        <li>Refunds to platform wallet: 24-48 hours</li>
                        <li>Investigation period: Up to 14 business days</li>
                    </ul>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>6. Non-Refundable Items</h2>
                    <p>
                        The following are strictly non-refundable:
                    </p>
                    <ul>
                        <li>Referral bonuses already credited</li>
                        <li>Daily income already claimed</li>
                        <li>Completed investment products</li>
                        <li>Withdrawal tax deductions</li>
                        <li>Amounts lost due to account misuse</li>
                    </ul>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>7. How to Request a Refund</h2>
                    <p>
                        To request a refund:
                    </p>
                    <ol>
                        <li>Go to Support section in the app</li>
                        <li>Contact us via WhatsApp or Telegram</li>
                        <li>Provide your registered email and transaction details</li>
                        <li>Explain the reason for your refund request</li>
                        <li>Attach any relevant screenshots or proof</li>
                    </ol>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>8. Refund Denial</h2>
                    <p>
                        Refund requests may be denied if:
                    </p>
                    <ul>
                        <li>The request violates our Terms of Service</li>
                        <li>Fraud or abuse is detected</li>
                        <li>The transaction is outside the refund scope</li>
                        <li>Insufficient documentation is provided</li>
                    </ul>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>9. Dispute Resolution</h2>
                    <p>
                        If you disagree with a refund decision:
                    </p>
                    <ul>
                        <li>Contact our support team for review</li>
                        <li>Provide additional documentation if available</li>
                        <li>Our team will conduct a final review within 7 days</li>
                    </ul>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>10. Contact Us</h2>
                    <p>
                        For refund-related queries, please contact us:
                    </p>
                    <ul>
                        <li>Email: refunds@yonexai.com</li>
                        <li>Support: Through the app's Support section</li>
                        <li>Response time: Within 24-48 hours</li>
                    </ul>
                </GlassCard>
            </div>
        </div>
    );
};

export default RefundScreen;
